// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-forms-modal {
  padding-bottom: 0 !important;
}
.statistics-forms-modal .forms--container {
  min-height: 300px;
  display: flex;
  gap: 32px;
  align-items: stretch;
}
.statistics-forms-modal .forms--container .no--result {
  padding: 24px 27px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: #101828;
}
.statistics-forms-modal .forms--container .forms--suggest {
  width: 100%;
  max-width: 426px;
}
.statistics-forms-modal .forms--container .forms--suggest .forms--suggest__list {
  height: 100%;
  max-height: 384px;
  overflow: hidden auto;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: #ffffff;
}
.statistics-forms-modal .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox {
  min-height: 64px;
  width: 100%;
  margin-bottom: 0;
  padding: 14px 27px;
}
.statistics-forms-modal .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox:nth-child(n+2) {
  border-top: 1px solid #dadee4;
}
.statistics-forms-modal .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .input {
  margin-top: -14px;
  margin-left: -27px;
}
.statistics-forms-modal .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .label {
  display: flex;
  align-items: center;
}
.statistics-forms-modal .forms--container .selected--forms .selected--forms__title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: var(--Secondary-On-Surface, #98a2b3);
}
.statistics-forms-modal .forms--container .selected--forms .selected--forms__list {
  margin-top: 15px;
}
.statistics-forms-modal .forms--container .selected--forms .selected--forms__list .item {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.statistics-forms-modal .forms--container .selected--forms .selected--forms__list .item:nth-child(n+2) {
  margin-top: 8px;
}
.statistics-forms-modal .forms--container .selected--forms .selected--forms__list .item svg {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/reports/statistics/components/FormsModal/styles.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;AACE;EACE,iBAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;AACJ;AACI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACN;AAEI;EACE,WAAA;EACA,gBAAA;AAAN;AAEM;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAAR;AAEQ;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAAV;AAEU;EACE,6BAAA;AAAZ;AAGU;EACE,iBAAA;EACA,kBAAA;AADZ;AAIU;EACE,aAAA;EACA,mBAAA;AAFZ;AASM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;AAPR;AAUM;EACE,gBAAA;AARR;AAUQ;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AARV;AAUU;EACE,eAAA;AARZ;AAWU;EACE,eAAA;AATZ","sourcesContent":[".statistics-forms-modal {\n  padding-bottom: 0 !important;\n\n  .forms--container {\n    min-height: 300px;\n    display: flex;\n    gap: 32px;\n    align-items: stretch;\n\n    .no--result {\n      padding: 24px 27px;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      color: #101828;\n    }\n\n    .forms--suggest {\n      width: 100%;\n      max-width: 426px;\n\n      .forms--suggest__list {\n        height: 100%;\n        max-height: 384px;\n        overflow: hidden auto;\n        border-top-left-radius: 6px;\n        border-top-right-radius: 6px;\n        background-color: #ffffff;\n\n        .form-control-checkbox {\n          min-height: 64px;\n          width: 100%;\n          margin-bottom: 0;\n          padding: 14px 27px;\n\n          &:nth-child(n + 2) {\n            border-top: 1px solid #dadee4;\n          }\n\n          .input {\n            margin-top: -14px;\n            margin-left: -27px;\n          }\n\n          .label {\n            display: flex;\n            align-items: center;\n          }\n        }\n      }\n    }\n\n    .selected--forms {\n      .selected--forms__title {\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        color: var(--Secondary-On-Surface, #98a2b3);\n      }\n\n      .selected--forms__list {\n        margin-top: 15px;\n\n        .item {\n          display: flex;\n          gap: 10px;\n          align-items: center;\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 20px;\n\n          &:nth-child(n + 2) {\n            margin-top: 8px;\n          }\n\n          svg {\n            cursor: pointer;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
